import {useEffect, useState} from 'react'
import axios from 'axios'

export const useData = (url, debounce = 0, initialData = null) => {

	const [localUrl, setLocalUrl] = useState(url)
	const [state, setState] = useState(initialData !== null ? {
		state: "FULFILLED",
		result: initialData,
		error: null,
		url: url,
	} : {
		state: "PENDING",
		result: null,
		error: null,
	})

	let tout = null
	useEffect(() => {
		if(debounce) {
			tout = setTimeout(() => {
				setLocalUrl(url)
			}, debounce)
			return () => clearTimeout(tout)
		} else {
			setLocalUrl(url)
		}
	}, [url, debounce])

	useEffect(() => {
		if (state.url === localUrl) return
		setState({
			state: "PENDING",
			result: state.result,
			error: null,
		})

		let frozenUrl = localUrl
		axios.get(frozenUrl, {withCredentials: true}).then(result => {
			if(frozenUrl != localUrl) return

			setState({
				state: "FULFILLED",
				result: result.data,
				error: null,
			})
		}).catch(error => {
			if(frozenUrl != localUrl) return
			
			setState({
				state: "REJECTED",
				result: null,
				error: error,
			})
		})
	}, [localUrl])
	return state
}

export const useDataWithToken = (url, tokenGetter, debounce = 0, initialData = null) => {
	const [state, setState] = useState(initialData !== null ? {
		state: "FULFILLED",
		result: initialData,
		error: null,
		url,
	} : {
		state: "PENDING",
		result: null,
		error: null,
	})
	useEffect(() => {
    const abortController = new AbortController();
		if (!url) return
    const tout = setTimeout(() => {
      setState({
        state: "PENDING",
        result: state.result,
        error: null,
      })

      tokenGetter().then(token => {
        fetch(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          signal: abortController.signal,
        }).then((response) => {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject();
        }).then(result => {
          setState({
            state: "FULFILLED",
            result,
            error: null,
          })
        }).catch(error => {        
          setState({
            state: "REJECTED",
            result: null,
            error: error,
          })
        })
      })
    }, debounce)

    return () => {
      clearTimeout(tout)
      abortController.abort();
    };
	}, [url])
	return state
}
